module.exports = {
      id: "login-usage",
      viewBox: "0 0 14.742 20.333",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#login",
      toString: function () {
        return this.url;
      }
    }